import queryClient from "@/queryClient";

import { getSpApi, requestConfig } from "./apiRoot";
import { UrlManager } from "./UrlManager";

// Swagger: https://ibpcsrcdev01.portima.net/mybrokerapi/swagger/index.html

const checkData = async <Params>(url: string, params: Params): Promise<void> => {
    const axiosRequestConfig = requestConfig<Params>({ params });
    await getSpApi().get(url, axiosRequestConfig);
};

const queryCheckData = async <Params>(key: string, url: string, params: Params): Promise<boolean> => {
    try {
        await queryClient.fetchQuery({
            queryKey: [key, params],
            queryFn: () => checkData(url, params),
        });
        return true;
    } catch {
        return false;
    }
};

export const queryCheckBankAccount = async (bankAccountType: string, bankAccountNumber: string): Promise<boolean> =>
    queryCheckData("checkBankAccount", UrlManager.checkBankAccount(), {
        bankAccountType,
        bankAccountNumber,
    });

export const queryCheckEmail = async (email: string): Promise<boolean> =>
    queryCheckData("checkEmail", UrlManager.checkEmail(), {
        email,
    });

export const queryCheckBelgianVAT = async (vat: string): Promise<boolean> =>
    queryCheckData("checkBelgianVAT", UrlManager.checkBelgianVAT(), {
        vat,
    });

export const queryCheckUnitEstablishNumber = async (unitEstablishNumber: string): Promise<boolean> =>
    queryCheckData("checkUnitEstablishNumber", UrlManager.checkUnitEstablishNumber(), {
        unitEstablishNumber,
    });

export const queryCheckBCENumber = async (bceNumber: string): Promise<boolean> =>
    queryCheckData("checkBCENumber", UrlManager.checkBceNumber(), {
        bceNumber,
    });

export const queryCheckPhoneNumber = async (
    phoneNumber: string,
    region?: string,
    mobileOnly?: boolean,
): Promise<boolean> =>
    queryCheckData("checkPhoneNumber", UrlManager.checkPhoneNumber(), {
        phoneNumber: phoneNumber.replace(/\s/g, ""),
        region,
        mobileOnly,
    });
